import { Box, ButtonBase, Tooltip } from "@mui/material";

type Props = {
    nombre: string;
    children: React.ReactNode;
    onClick?: () => void;
    placement?: "right" | "bottom" | "left" | "top" | "bottom-end" | "bottom-start" | "left-end" | "left-start" | "right-end" | "right-start" | "top-end" | "top-start" | undefined;
    isActive?: boolean;
    size?: 'small' | 'medium' | 'large';
};

export const ButtonTip: React.FC<Props> = ({
    nombre,
    children,
    onClick,
    placement = 'right',
    isActive = false,
    size = 'medium',
}) => {
    const sizeStyles = {
        small: {
            width: 32,
            height: 32,
            fontSize: '0.75rem',
        },
        medium: {
            width: 40,
            height: 40,
            fontSize: '0.875rem',
        },
        large: {
            width: 48,
            height: 48,
            fontSize: '1rem',
        },
    };

    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            sx={{
                borderBottom: isActive ? '2px solid white' : 'none',
            }}
        >
            <Tooltip title={nombre} placement={placement}>
                <ButtonBase
                    onClick={onClick}
                    sx={{
                        ...sizeStyles[size],
                        bgcolor: '#223265', 
                        color: 'white',                 
                        borderRadius: '50%',            
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transition: 'background 0.3s',
                        '&:hover': {
                            bgcolor: '#172346', 
                        },
                    }}
                >
                    {children}
                </ButtonBase>
            </Tooltip>
        </Box>
    );
};